/** React */
import { HtmlHTMLAttributes } from "react";

/** CSS */
import "./index.css";

import Button from "../button";
import { IoPause, IoPlay, IoStop } from "react-icons/io5";

/** Props */
type Props = HtmlHTMLAttributes<HTMLDivElement> & {
  indexPosition: number;
  isPlay: boolean;
  handlePlay: () => void;
  handleStop: () => void;
};

export function RangeControls({
  indexPosition,
  isPlay,
  handlePlay,
  handleStop,
}: Props) {
  return (
    <>
      <Button
        mode="icon"
        size="small"
        className="range__play"
        onClick={handlePlay}
      >
        {isPlay ? (
          <IoPause size={"2rem"} />
        ) : (
          <IoPlay size={"2rem"} />
        )}
      </Button>

      <Button
        mode="icon"
        size="small"
        className="range__play"
        disabled={!isPlay && indexPosition === 0}
        onClick={handleStop}
      >
        <IoStop size={"2rem"} />
      </Button>
    </>
  );
}
